export default {
  SET_SUBJECT_SEARCH(state: any, subjectSearch: any) {
    let subjectInfo = subjectSearch.map(elasticQuestion => {
      return {
        id: elasticQuestion.id,
        score: elasticQuestion.score,
      };
    });
    state.subjectSearch = subjectInfo;
  },
  CLEAN_SUBJECT_SEARCH(state: any) {
    state.subjectSearch = [];
  },
};
